import { IconButton, InputAdornment, MenuItem, TextField } from '@mui/material';
import i18n from '../../i18n';
import React from 'react';
import ClearIcon from '@mui/icons-material/Clear';

export class DialogEntityField extends React.Component {
    handleClear = () => {
        this.props.onChange(this.props.field.id, null);
    };
    render() {
        const { items, id, label: labelKey } = this.props.field;
        const label = i18n.t(`columns.${labelKey}`);

        return (
            <TextField
                key={id}
                id={id}
                name={id}
                select
                label={label}
                fullWidth
                value={this.props.value || ''}
                onChange={(event) =>
                    this.props.onChange(event.target.name, event.target.value)
                }
                InputProps={{
                    endAdornment: this.props.value ? (
                        <InputAdornment position="end">
                            <IconButton onClick={this.handleClear} edge="end">
                                <ClearIcon />
                            </IconButton>
                        </InputAdornment>
                    ) : null
                }}
                SelectProps={{
                    IconComponent: this.props.value ? () => null : undefined,
                    MenuProps: {
                        PaperProps: {
                            style: {
                                maxHeight: 300,
                                overflow: 'auto'
                            }
                        }
                    }
                }}
            >
                {items.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                        {item.name}
                    </MenuItem>
                ))}
            </TextField>
        );
    }
}
